import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import './PaymentSuccessPage.css';

const PaymentSuccessPage = () => {
  const location = useLocation();
  const sessionDetails = location.state?.sessionDetails || {};

  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  return (
    <div className="success-container">
      <header className="success-header">
        <h1>RGVSMARTPAY</h1>
      </header>

      <main className="success-content">
        <div className="success-card">
          <div className="success-icon">
            <svg viewBox="0 0 24 24" width="60" height="60" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 11.08V12C21.9988 14.1564 21.3005 16.2547 20.0093 17.9818C18.7182 19.709 16.9033 20.9725 14.8354 21.5839C12.7674 22.1953 10.5573 22.1219 8.53447 21.3746C6.51168 20.6273 4.78465 19.2461 3.61096 17.4371C2.43727 15.628 1.87979 13.4881 2.02168 11.3363C2.16356 9.18455 2.99721 7.13631 4.39828 5.49706C5.79935 3.85781 7.69279 2.71537 9.79619 2.24013C11.8996 1.7649 14.1003 1.98232 16.07 2.85999" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M22 4L12 14.01L9 11.01" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <h2>Payment Successful!</h2>
          <p className="success-message">Your parking session has been confirmed.</p>
          
          <div className="session-details">
            <div className="detail-row">
              <span>License Plate:</span>
              <span>{sessionDetails.license_plate || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span>Zone:</span>
              <span>{sessionDetails.zone_code || 'N/A'}</span>
            </div>
            <div className="detail-row">
              <span>Start Time:</span>
              <span>{formatDateTime(sessionDetails.start_time)}</span>
            </div>
            <div className="detail-row">
              <span>End Time:</span>
              <span>{formatDateTime(sessionDetails.end_time)}</span>
            </div>
            <div className="detail-row">
              <span>Duration:</span>
              <span>{sessionDetails.duration || 0} minutes</span>
            </div>
            <div className="detail-row total">
              <span>Amount Paid:</span>
              <span>${sessionDetails.amount_paid || '0.00'}</span>
            </div>
          </div>
          
          <p className="receipt-note">A receipt has been sent to your email.</p>
          
          <div className="success-actions">
            <Link to="/" className="home-button">Return to Home</Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PaymentSuccessPage; 